import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Leden from './views/Leden.vue';
import Besturen from './views/Besturen.vue';
import Gallerij from './views/Gallery/Gallery.vue';
import Album from './views/Gallery/Albums/Show.vue';
import NotFound from './views/NotFound.vue';
import { applyMetadata, metadataFor } from './metadata';
import store from './store';
import { prefersReducedMotion } from './store/candles';

Vue.use(Router);

// Upper bound for the candle animation, so a failure can never block a navigation.
const EXTINGUISH_TIMEOUT_MS = 1500;
let firstNavigation = true;

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        titleKey: 'metadata.home_title',
        descriptionKey: 'metadata.home_description',
      },
    },
    {
      path: '/Leden',
      name: 'Leden',
      component: Leden,
      meta: {
        titleKey: 'metadata.members_title',
        descriptionKey: 'metadata.members_description',
      },
    },
    {
      path: '/Bestuur',
      name: 'Bestuur',
      component: Besturen,
      meta: {
        titleKey: 'metadata.board_title',
        descriptionKey: 'metadata.board_description',
      },
    },
    {
      path: '/Gallerij',
      name: 'Gallerij',
      component: Gallerij,
      meta: {
        titleKey: 'metadata.gallery_title',
        descriptionKey: 'metadata.gallery_description',
      },
    },
    {
      path: '/Gallerij/Album/:slug',
      name: 'Album',
      component: Album,
      props: true,
      meta: {
        titleKey: 'metadata.album_title',
        descriptionKey: 'metadata.gallery_description',
      },
    },
    // Anything else: the server answers the same paths with a real 404.
    {
      path: '*',
      name: 'notFound',
      component: NotFound,
      meta: {
        titleKey: 'metadata.not_found_title',
        descriptionKey: 'metadata.not_found_description',
        canonical: false,
      },
    },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    // },
  ],
});

// The candles go out before the page changes, except on the first load, on a
// navigation to the current route and when the visitor prefers reduced motion.
router.beforeEach((to, from, next) => {
  if (firstNavigation || to.fullPath === from.fullPath || prefersReducedMotion()) {
    next();
    return;
  }

  let proceeded = false;
  const proceed = () => {
    if (!proceeded) {
      proceeded = true;
      next();
    }
  };

  setTimeout(proceed, EXTINGUISH_TIMEOUT_MS);
  store.dispatch('candles/extinguish').then(proceed, proceed);
});

router.afterEach((to) => {
  applyMetadata(metadataFor(to));
  firstNavigation = false;
  store.dispatch('candles/ignite');
});

// Data that arrives after the navigation (the hero, an album) completes the metadata of the page.
store.subscribe((mutation) => {
  if (['intro/SET_SITE', 'intro/SET_ALBUM_PAGE'].indexOf(mutation.type) !== -1 && !firstNavigation) {
    applyMetadata(metadataFor(router.currentRoute));
  }
});

export default router;
